import {Component, Inject, Input, OnChanges, OnInit} from '@angular/core';
import {ConfService} from '../conf.service';
import {ConnecttocrudService} from '../connecttocrud.service';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import {MatSnackBar} from '@angular/material';
import {AttributesListComponent} from '../attributes-list/attributes-list.component';
import {LeftpanelComponent} from '../leftpanel/leftpanel.component';

declare let $;

@Component({
  selector: 'app-api-new',
  templateUrl: './api-new.component.html',
  styleUrls: ['./api-new.component.scss']
})
export class ApiNewComponent implements OnInit, OnChanges {
  filterData: any[];
  @Input() type: any;
  searchText: any;
  columns1: string[] = [];
  columns: string[] = [];
  itemLength: any;
  error = false;
  sourcepartner: string;
  dataSource: any;
  sourceaccount: string;
  partner: string;
  panelOpenState = false;
  account: string;
  entity: string;
  version: string;
  addData: any;
  executor_name: string;
  url: string;
  data: any;
  primaryKey = null;
  languages: any;
  language: string;
  parameters: [];
  headers: any;
  itemList: any[];
  items: any;
  options: any;
  apiByDefinition: any;
  partnerKey: string;
  languageSelected: string;
  errorMessage: string;
  @Input() Title: any;
  @Input() Image: any;
  @Input() Summary: any;
  @Input() source: any;
  @Input() attributetype: any;
  @Input() schema: any;
  sourceType: any;
  temp: any;
  addButtonText = 'Insert Data';
  searchFlag = true;
  addFlag = true;
  deleteFlag = true;
  updateFlag = true;
  addUrl: any;
  dataModel: any;
  updateUrl: any;
  deleteUrl: any;
  patchUrl: any;
  getUrl: any;
  // @Input() insertUrl: string;
  // @Input() updateUrl: string;
  // @Input() ButtonConfig: any;
  condition: any;
  settings = {text: 'Select attribute(s) to search instantly'};
  constructor( public confPost: ConfService, public _service: ConnecttocrudService,
               public dialog: MatDialog, public snackBar: MatSnackBar, private platform: LeftpanelComponent) { }
  ngOnInit() {

    // this.getLanguages();
    if (this.platform.languages !== null && this.platform.languages !== undefined) {
      this.languages = this.platform.languages;
    } else {
      this.platform.getLanguages();
      this.languages = this.platform.languages;
    }
    $(document).ready(function () {
      $('#myInput2').on('keyup', function () {
        var value = $(this).val().toString().toLowerCase();
        $('.searc').filter(function () {
          $(this).toggle($(this).text().toLowerCase().indexOf(value) > -1);
          return true;
        });
      });
    });
  }

  ngOnChanges() {
    if (this.source) {
      if (this.source.sourcetype === 'entity') {
        this.entityHandler();
      } else if (this.source.sourcetype === 'executor_model') {
        this.executorHandler();
      } else if (this.source.sourcetype === 'api_call') {
        this.apiCallHandler();
      } else if (this.source.sourcetype === 'data') {
        this.headers = this.source.headers;
        this.dataHandler();
      } else {
        this.errorMessage = 'Error in source type';
      }
    }
  }

  entityHandler() {
      this.sourcepartner = this.source.partner;
      this.sourceaccount = this.source.account;
      this.partner = localStorage.getItem('partner');
      this.account = localStorage.getItem('account');
      this.entity = this.source.entity;
      this.version = this.source.version;
      if (this.source.condition) {
        this.condition = this.source.condition;
      }
      this.language = 'en';
      this.languageSelected = this.language;
      // this.partnerKey = localStorage.getItem('partnerKey');
      this.items = null;
      this.getitems();
  }
  // getLanguages() {
  //   this.confPost.getLanguages().subscribe(
  //       items => {
  //         this.languages = items;
  //       },
  //       error => {
  //         this.platform.openSnackBar('Error while fetching list of languages: ' + error.error.message, 'Error', {
  //           duration: 5000,
  //           verticalPosition: 'top',
  //           horizontalPosition: 'center'
  //         });
  //       }
  //   );
  // }
  executorHandler() {
    this.partner = this.source.partner;
    this.account = this.source.account;
    this.executor_name = this.source.executor_name;
    this.version = this.source.version;
    this.confPost.getApiExecutorByPartnerAccountEntityVersion(this.partner, this.account, this.executor_name, this.version)
        .subscribe( data => {
          this.data = data;
        }, error => {
          this.platform.handleErrorGracefully(error, 'Error while retrieving the API executor by entity and version. Please try again after sometime.');
        });
  }
  apiCallHandler() {
    const payload = {
      'executor_name': this.source.executor_name,
      'executor_type': this.source.executor_type !== null ? this.source.executor_type : 'API',
      'executor_version': this.source.executor_version,
      'executor_method_type': this.source.httpOperation,
      'apiUrl': this.source.httpUrl,
      'dataroot': null,
      'queryParams': this.source.parameterData,
      'pathParams': this.source.pathParameter,
      'headers': this.source.headersData,
      'requestBody': this.source.requestBody,
      'executors': this.source.executors,
      'prerequisites': null,
      'authModel': this.source.authModel
    };
    this._service.executeApi(payload).subscribe(response2 => {
      this.items = response2.body;
    }, error => {
      this.platform.handleErrorGracefully(error, 'Error while executing the API. Please try again after sometime.');
    });
    for (const item of this.items) {
      this.columns = [];
      this.columns1 = [];
      for (const itemval in item) {
        this.columns.push(itemval);
        this.columns1.push(itemval);
      }
    }
    this.itemList = [];
    for (let t = 0; t < this.columns.length; t++) {
      const tempObj = {};
      tempObj['id'] = t;
      tempObj['itemName'] = this.columns[t];
      this.itemList.push(tempObj);
    }
  }
  async dataHandler() {
    if (this.source.data === undefined) {
      this.items = [];
    } else {
      this.items = this.source.data;
    }
    for (const item of this.items) {
      this.columns = [];
      this.columns1 = [];
      for (const itemval in item) {
        this.columns.push(itemval);
        this.columns1.push(itemval);
      }
    }
    this.itemList = [];
    for (let t = 0; t < this.columns.length; t++) {
      const tempObj = {};
      tempObj['id'] = t;
      tempObj['itemName'] = this.columns[t];
      this.itemList.push(tempObj);
    }
    await this.confPost.getAttributeSchemaofJSONString(localStorage.getItem('partner'),
        localStorage.getItem('account'), this.source.data).toPromise().then (res => {
      this.dataSource = res.body;
    }, error => {
      this.platform.handleErrorGracefully(error, 'Error while retrieving the attribute schema of JSON string. Please try again after sometime.');
    });
    this.getDataModel();
  }
  typeOfval(val) {
    return typeof val;
  }
  stringifyjson(val) {
    return JSON.stringify(val, null, 2).trim();
  }
  getitems() {
    this.error = false;
    this.confPost.getEntity(this.sourcepartner, this.sourceaccount, this.entity, this.version).subscribe(data => {
      this.apiByDefinition = data;
      this._service.getItemswithParameter(this.version, this.sourcepartner, this.sourceaccount, this.entity, 'partner=' + this.partner + '&account=' + this.account).subscribe(
          items => {
            this.items = items;
            // this.itemLength = this.items.length;
            for (const item of this.items) {
              this.columns = [];
              this.columns1 = [];
              for (const itemval in item) {
                this.columns.push(itemval);
                this.columns1.push(itemval);
              }
            }
            if (this.apiByDefinition && this.apiByDefinition.attributes) {
              for (let i = 0; i < this.apiByDefinition.attributes.length; i++) {
                for (let j = 0; j < this.columns.length; j++) {
                  if (this.apiByDefinition['attributes'][i]['attributeName'] === this.columns[j]) {
                    if (this.apiByDefinition['attributes'][i]['displayName'] !== null
                        && this.apiByDefinition['attributes'][i]['displayName'] !== '') {
                      this.columns1[j] = this.apiByDefinition['attributes'][i]['displayName'];
                    }
                  }
                }
              }
            }
            this.itemList = [];
            for (let t = 0; t < this.columns.length; t++) {
              const tempObj = {};
              tempObj['id'] = t;
              tempObj['itemName'] = this.columns[t];
              this.itemList.push(tempObj);
            }
            this.options = {
              fieldSeparator: ',',
              quoteStrings: '',
              decimalseparator: '.',
              headers: this.columns,
              showTitle: false,
              useBom: true,
              noDownload: false,
              nullToEmptyString: true,
              removeNewLines: false,
              keys: []
            };
          },
          error => {
            this.error = true;
            this.errorMessage = (error !== null && error !== undefined && error.error !== null && error.error !== undefined) ? error.error.message : 'Error while getting item';
          }
      );
      this.confPost.getPartnerEntity(this.sourceaccount, this.entity, this.sourcepartner).subscribe(items => {
        this.dataSource = items[0].attributes;
        this.getDataModel();
      }, error => {
        this.platform.handleErrorGracefully(error, 'Error while retrieving the entity. Please try again after sometime.');
      });
    }, error => {
      this.platform.handleErrorGracefully(error, 'Error while retrieving the entity. Please try again after sometime.');
    });

  }
  openViewDialog(a) {
      const dialogRef = this.dialog.open(ViewDialogComponent, {
        width: '60%',
        data: this.items[a]
      });

      dialogRef.afterClosed().subscribe(result => {
      });
    }
    openEditDialog(a, id: string): void {
      const dialogRef = this.dialog.open(EditDialogComponent, {
        width: '60%',
        data: this.items[a]
      });
      dialogRef.afterClosed().subscribe(result => {
        if (result) {
          if (this.source.sourcetype === 'data') {
            this.temp = {};
            this.temp[this.attributetype] = this.items;
            this.confPost.patchGenericCall(this.source.patchUrl, this.temp, this.headers).subscribe(res => {
                  this.platform.openSnackBar('Data Added successfully', 'Success', {
                    duration: 2000,
                    verticalPosition: 'top',
                    horizontalPosition: 'center'
                  });
                },
                error => {
                  this.platform.handleErrorGracefully(error, 'Something went wrong. Please try after sometime.');
                });
          } else if (this.source.sourcetype === 'entity') {
            this._service.patchItemUpdate(this.items[a]['id'], this.items[a], this.version, this.sourcepartner, this.sourceaccount, this.entity).subscribe(
                status => {
                  this.platform.openSnackBar('Data updated successfully', 'Success', {
                    duration: 5000,
                    verticalPosition: 'top',
                    horizontalPosition: 'center'
                  });
                },
                error => {
                  this.platform.handleErrorGracefully(error, 'Something went wrong. Please try after sometime.');
                });
          }
        }


      });
    }
    typeof(object) {
      let stringConstructor = 'test'.constructor;
      let arrayConstructor = [].constructor;
      let objectConstructor = ({}).constructor;

      if (object === null) {
        return 'null';
      }
      if (object === undefined) {
        return 'undefined';
      }
      if (object.constructor === stringConstructor) {
        return 'String';
      }
      if (object.constructor === arrayConstructor) {
        return 'array';
      }
      if (object.constructor === objectConstructor) {
        return 'object';
      }
      {
        return 'don\'t know';
      }
    }
    setDataZero(data) {
      for (const item of this.items) {
        if (this.typeof(item) !== 'array' && this.typeof(item) !== 'object') {
          for (const itemval in item) {
            data[itemval] = null;
          }
        } else if (this.typeof(item) === 'array') {
        } else if (this.typeof(item) === 'object') {
        }
      }
    }
    openAddDialog(): void {
      if (this.source.sourcetype === 'data') {
          this.confPost.generatePayloadFromAttributes(localStorage.getItem('account'), localStorage.getItem('partner'), this.schema).subscribe(data => {
            this.addData = JSON.parse(JSON.stringify(data.body));
            const dialogRef = this.dialog.open(AddDialogComponent, {
              width: '60%',
              data: this.addData
            });
            dialogRef.afterClosed().subscribe(result => {
              if (result) {
                if (this.source.sourcetype === 'data') {
                  this.items.push(this.addData);
                  this.temp = {};
                  this.temp[this.attributetype] = this.items;
                  this.confPost.patchGenericCall(this.source.patchUrl, this.temp, this.headers).subscribe(res => {
                        this.platform.openSnackBar('Data Added successfully', 'Success', {
                          duration: 2000,
                          verticalPosition: 'top',
                          horizontalPosition: 'center'
                        });
                      },
                      error => {
                        this.platform.openSnackBar('Something went wrong. Please try after sometime', 'Error', {
                          duration: 5000,
                          verticalPosition: 'top',
                          horizontalPosition: 'center'
                        });
                      });
                }
              }
            });
          });
      } else if (this.source.sourcetype === 'entity') {
          this.getDataModelSchema();
          this.addData = JSON.parse(JSON.stringify(this.dataModel));
          const dialogRef = this.dialog.open(AddDialogComponent, {
            width: '60%',
            data: this.addData
          });
          dialogRef.afterClosed().subscribe(result => {
            if (result) {
              if (this.source.sourcetype === 'entity') {
                this._service.addItem(this.addData, this.version, this.sourcepartner, this.sourceaccount, this.entity).subscribe(
                    status => {
                      this.items.push(this.addData);
                      this.platform.openSnackBar('Data Added successfully', 'Success', {
                        duration: 5000,
                        verticalPosition: 'top',
                        horizontalPosition: 'center'
                      });
                    },
                    error => {
                      this.platform.openSnackBar('Something went wrong. Please try after sometime', 'Error', {
                        duration: 5000,
                        verticalPosition: 'top',
                        horizontalPosition: 'center'
                      });
                    }
                );
              }
            }
          });
      }
      }
  getDataModelSchema() {
    this.dataModel = {};
    const that = this;
    this.apiByDefinition.attributes.forEach((data) => {
      // if (data.array === true && data.type === 'Integer') {
      //     this.dataModel[data.attributeName] = ['ArrayOfNumbers'];
      // } else if (data.array === true && data.type === 'String') {
      //     this.dataModel[data.attributeName] = ['ArrayOfStrings'];
      //
      if ( data.array === true ) {
        if ( data.type === 'Object') {
          this.dataModel[data.attributeName] = (that.getSub(data.subType).length > 0 ? that.getSub(data.subType) : []);
        } else {
          if (data.type.includes('_')) {
            this.dataModel[data.attributeName] = ['' + ' (id)'];
          } else {
            this.dataModel[data.attributeName] = '';
          }
        }
      } else if (data.type === 'Object') {
        this.dataModel[data.attributeName] = (that.getSub(data.subType).length > 0 ? that.getSub(data.subType) : []);
        this.dataModel[data.attributeName] = this.dataModel[data.attributeName][0];

      } else if (data.type !== 'Array' && data.type !== 'Object' && data.type !== 'Array Of Strings' && data.type !== 'Array Of Numbers' && data.type !== 'Integer' && data.type !== 'Boolean' && !(data.type.includes('_'))) {
        this.dataModel[data.attributeName] = '';
        // } else if (data.type === 'Array Of Strings' || data.type === 'Array Of Numbers') {
        //     this.dataModel[data.attributeName] = [];
      } else if (data.type === 'Integer') {
        this.dataModel[data.attributeName] = '';
      } else if (data.type === 'Boolean') {
        this.dataModel[data.attributeName] = '';
      } else if (data.type.includes('_')) {
        this.dataModel[data.attributeName] = '' + ' (id)';
      }
    });
    return this.dataModel;
  }
  getSub(data) {
    const subType = [];
    const obj = {};
    const that = this;
    if (data.length > 0) {
      data.forEach((result) => {
        if ( result.array === true ) {
          if ( result.type === 'Object') {
            obj[result.attributeName] = (that.getSub(result.subType).length > 0 ? that.getSub(result.subType) : []);
          } else {
            if (result.type.includes('_')) {
              obj[result.attributeName] = ['' + ' (id)'];
            } else {
              obj[result.attributeName] = [''];
            }                    }
        } else if (result.type === 'Object') {
          obj[result.attributeName] = (that.getSub(result.subType).length > 0 ? that.getSub(result.subType) : []);
          obj[result.attributeName] = obj[result.attributeName][0];

        } else if (result.type !== 'Array' && result.type !== 'Object' && result.type !== 'Array Of Strings' && result.type !== 'Array Of Numbers' && result.type !== 'Integer' && result.type !== 'Boolean' && !(result.type.includes('_'))) {
          obj[result.attributeName] = '';
          // } else if (result.type === 'Array Of Strings' || result.type === 'Array Of Numbers') {
          //     obj[result.attributeName] = [];
        } else if (result.type === 'Integer') {
          obj[result.attributeName] = '';
        } else if (result.type === 'Boolean') {
          obj[result.attributeName] = '';
        } else if (result.type.includes('_')) {
          obj[result.attributeName] = '' + ' (id)';
        }

        // if (result.array === true && result.type === 'Integer') {
        //     obj[result.attributeName] = ['ArrayOfNumbers'];
        // } else if (result.type != 'Array' && result.type != 'Object' && result.type != 'Array Of Strings' && result.type != 'Array Of Numbers' && result.type != 'Integer' && result.type != 'Boolean') {
        //     obj[result.attributeName] = result.type;
        // } else if (result.type === 'Array' || result.type === 'Object'){
        //     obj[result.attributeName] = (that.getSub(result.subType).length > 0 ? that.getSub(result.subType) : []);
        // } else if (result.type === 'Array Of Strings' || result.type === 'Array Of Numbers') {
        //     obj[result.attributeName] = [];
        // } else if (result.type === 'Integer') {
        //     obj[result.attributeName] = 0;
        // } else if (result.type === 'Boolean') {
        //     obj[result.attributeName] = false;
        // }
      });
      subType.push(obj);
    }
    return subType;
  }

  // this.addData = JSON.parse(JSON.stringify(this.items[this.items.length - 1]));
    openDeleteDialog(a, id: string, event) {
      if (confirm('This action is irreversible, Are you sure you want to delete this record?')) {
        if (this.source) {
          if (this.source.sourcetype === 'entity') {
            this._service.deleteItem(id, this.version, this.sourcepartner, this.sourceaccount, this.entity).subscribe(
                agents => {
                  this.platform.openSnackBar('Deleted successfully', 'Success', {
                    duration: 2000,
                    verticalPosition: 'top',
                    horizontalPosition: 'center'
                  });
                  const itemDuplicate = this.items;
                  const deleteditem =  itemDuplicate.findIndex(p => p && p.id === id);
                  delete this.items[deleteditem];
                  //  this.removeItemFromUI(event);
                },
                error => {
                  this.platform.openSnackBar('Error while deleting this record: ' + (error !== null && error !== undefined && error.error !== null && error.error !== undefined) ? ': ' + error.error.message : '', 'Error', {
                    duration: 5000,
                    verticalPosition: 'top',
                    horizontalPosition: 'center'
                  });
                }
            );
          } else if (this.source.sourcetype === 'executor_model') {
          } else if (this.source.sourcetype === 'api_call') {
          } else if (this.source.sourcetype === 'data') {
            this.items.splice(a, 1);
            this.temp = {};
            this.temp[this.attributetype] = this.items;
            this.confPost.patchGenericCall(this.source.patchUrl , this.temp , this.headers).subscribe( res => {
                this.platform.openSnackBar('Deleted successfully', 'Success', {
                  duration: 2000,
                  verticalPosition: 'top',
                  horizontalPosition: 'center'
                });
            });
          } else {
            this.errorMessage = 'Error in source type';
          }
        }
      }
    }
  getDataModel() {
    const that = this;
    this.dataSource.forEach((data) => {
      if (data.type === 'ObjectId' && this.primaryKey == null) {
        this.primaryKey = 'id';
      } else if (data.attributeType === 'Primary' && this.primaryKey == null) {
        this.primaryKey = data.attributeName;
      }
    });
    if (this.primaryKey === null) {
      this.primaryKey = 'name';
    }
  }
}

@Component({
  selector: 'view-dialog',
  templateUrl: 'view-dialog.component.html',
  styleUrls: ['view-dialog.component.css']
})
export class ViewDialogComponent implements OnInit {
  constructor (public platform: LeftpanelComponent,
               public dialogRef: MatDialogRef <ViewDialogComponent>,
               @Inject(MAT_DIALOG_DATA) public data: any) { }
  ngOnInit(): void {
  }
  onNoClick(): void {
    this.dialogRef.close();
  }
  stringifyjson(val) {
    return JSON.stringify(val);
  }
}

@Component({
  selector: 'add-dialog',
  templateUrl: 'add-dialog.component.html',
  styleUrls: ['add-dialog.component.css']
})
export class AddDialogComponent implements OnInit {
  constructor (public platform: LeftpanelComponent,
               public dialogRef: MatDialogRef <AddDialogComponent>,
               @Inject(MAT_DIALOG_DATA) public data: any) {
  }
  async ngOnInit() {
  }
  saveData() {
    this.dialogRef.close(true);
  }
  stringifyjson(val) {
    return JSON.stringify(val);
  }
}

@Component({
  selector: 'edit-dialog',
  templateUrl: 'edit-dialog.component.html',
  styleUrls: ['edit-dialog.component.css']
})
export class EditDialogComponent implements OnInit {
  constructor (public platform: LeftpanelComponent,
               public dialogRef: MatDialogRef <EditDialogComponent>,
               @Inject(MAT_DIALOG_DATA) public data: any) { }
  ngOnInit(): void {
  }
  saveApi() {
    this.dialogRef.close(true);
  }
  stringifyjson(val) {
    return JSON.stringify(val);
  }
}
@Component({
  selector: 'delete-dialog',
  templateUrl: 'delete-dialog.component.html',
  styleUrls: ['delete-dialog.component.css']
})
export class DeleteDialogComponent implements OnInit {
  constructor (public platform: LeftpanelComponent,
               public dialogRef: MatDialogRef <DeleteDialogComponent>,
               @Inject(MAT_DIALOG_DATA) public data: any) { }
  ngOnInit(): void {
  }
  onNoClick(): void {
    this.dialogRef.close();
  }
}
